/**
 * Returns true when the nav item at `path` should appear active for the given `pathname`.
 *
 * - Exact match always wins.
 * - Nested routes highlight their section root (e.g. `/app/collection/abc` → Collection).
 * - `/app/settings/sessions` highlights Settings (no dedicated sidebar entry).
 * - `/app/settings/notifications` highlights only Notifications, not Settings.
 */
export function isNavItemActive(path: string, pathname: string): boolean {
  if (pathname === path) return true

  if (path === '/app/settings') {
    return pathname === '/app/settings/sessions'
  }

  if (pathname.startsWith(`${path}/`)) {
    return true
  }

  return false
}
